export default {
  submit: "提交",
  search: "搜索",
  reset: "重置",
  select: "选择",
  create: "创建",
  update: "更新",
  edit: "编辑",
  delete: "删除",
  add: "添加",
  remove: "移除",
  cancel: "取消",
  save: "保存",
  saved: "已保存",
  loading: "加载中...",
  error: "错误",
  success: "成功",
  warning: "警告",
  info: "信息",
  date: "日期",
  time: "时间",
  today: "今天",
  yesterday: "昨天",
  tomorrow: "明天",
  lastDays: "最近 {days} 天",
  upgrade: "升级",
  import: "导入",
  export: "导出",
  ok: "确定",
  close: "关闭",
  clear: "清空",
  retry: "重试",
  upload: "上传",
  row: "第 {row} 行",
  items: "项",
  yes: "是",
  no: "否",
  filter: "筛选",
  utc: "世界标准时间",
  london: "伦敦",
  paris: "巴黎",
  berlin: "柏林",
  shanghai: "上海",
  new_york: "纽约",
  los_angeles: "洛杉矶",
  privacy_policy: "查看隐私政策",
  email_placeholder: "请输入您的邮箱",
  empty_chart_action: "立即计算",
  preview: "预览",
  sign_out: "退出登录",
  invoice: "发票",
  credit_notes: "贷项凭证",
  trendChart: {
    export_image: "导出图片",
    this_month: "本月",
    last_month: "上月",
    month_before_last: "上上月",
    this_week: "本周",
    last_2_weeks: "近2周",
    last_4_weeks: "近4周",
    today: "今天",
    yesterday: "昨天",
    day_before_yesterday: "前天",
    month: "月",
    week: "周",
    day: "日",
    export_failed: "图表导出失败",
    export_retry: "图表导出失败，请重试",
  },
  view_all_news: "查看所有新闻",
  confirm: "确认",
  rangeSearch: "范围搜索",
  leg: {
    origin: "起始地",
    destination: "目的地",
    transportMode: "运输方式",
    distance: "距离 (公里)",
    weight: "重量 (t)",
    cnCode: "CN编码",
    transportEmission: "运输排放 (千克二氧化碳当量)",
    productionEmission: "生产排放 (千克二氧化碳当量)",
    totalEmission: "总排放 (千克二氧化碳当量)",
  },
  previewReports: {
    pdfPreview: "PDF预览",
    excelPreview: "Excel预览",
    payPerUse: "超出限制，按需使用？",
    payPerUseDownload: "按需下载",
    download: "下载",
    refresh: "刷新",
    darkModeWarning: "深色模式仅用于界面预览，不影响导出文件。导出文件将保持白色背景样式",
    upgradeToUnlockExcel: "升级到高级版以解锁Excel预览",
    unlockFeatures: "解锁Excel导出、自定义Logo、多语言等高级功能，提升报告专业性！",
    upgradeNow: "立即升级",
    previewFailed: "预览失败",
    excelPreviewRequiresPro: "Excel预览需要高级版订阅！",
    limitReached: "达到每日或每月限制",
    saved: "保存成功，您可以在报告列表中查看",
  },
  select_status: "选择状态",
  select_plan_type: "选择套餐类型",
  refund: "退款",
  view: "查看",
  start_date: "开始日期",
  end_date: "结束日期",
  view_details: "查看详情",
  back_to_login: "返回登录",
  view_count_description: "浏览次数表示通过分享链接查看该报告的总次数。取消分享不会重置此计数。",
  notify: {
    auto_renew: "自动续订",
    auto_renew_desc: "启用后将在计费周期结束时自动续订您的订阅。",
  },
  ticketTypes: {
    technical: "技术问题",
    billing: "账单问题",
    compliance: "合规咨询",
    feedback: "反馈与建议",
    other: "其他",
  },
  loading_verification: "加载验证中...",
  billing: {
    current_plan: "当前套餐",
    upgrade: "升级",
    manage: "查看账单",
    plan_type: "套餐类型",
    next_billing: "下次计费日期",
    expiry_date: "到期日期",
    expired: "已过期",
    permanent: "永久",
  },
  faq: {
    search_placeholder: "搜索常见问题...",
    no_results_title: "未找到结果",
    no_results_subtitle: "尝试调整搜索关键词或浏览左侧分类。",
    search_cleared_message: "已清除搜索，显示完整内容",
    still_have_questions: {
      before_email: "还有疑问？请联系 ",
      after_email: " — 我们的团队将在24小时内回复。",
    },
  },
};
